/* eslint-disable no-param-reassign */
/* eslint-disable no-continue */
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { MonicaObject, Room } from '../item';

export default class ItemLayer {
    modeNo: number;

    modeName: string;

    modeKey: string;

    childList:MonicaObject[] = [];

    public spt: SVGSprite;

    constructor(_no: number, _name: string, _key: string, layer: SVGSprite) {
      this.modeNo = _no;
      this.modeName = _name;
      this.modeKey = _key;

      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');

      viewObj.id = this.modeName;
      viewObj.classList.add('svgSprite');
      this.spt = new SVGSprite(viewObj);
      layer.addChild(this.spt);
    }

    /**
     * アイテム作成
     */
    addItem(item: MonicaObject):void {
      this.spt.addChild(item.spt);

      // アイテム一覧に追加
      this.childList.push(item);
    }

    /**
     * 未配置アイテムの削除
     */
    deleteUnplacedItems():void {
      let tarItem: MonicaObject;
      for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
        tarItem = this.childList[i];
        if (!tarItem.isFollowingMouse) {
          // 削除
          tarItem.deleteMe();
          this.childList.splice(i, 1);
        }
      }
    }

    /**
     * アイテムがあるか否か
     * @return boolean
     * */
    isItemInMe(): boolean {
      for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
        if ((this.childList[i] as MonicaObject).spt == null) {
          // リスト削除
          this.childList.splice(i, 1);
        }
      }
      return (this.childList.length > 0 as boolean);
    }

    /**
     * 子供一覧
     * */
    getAllChildren():MonicaObject[] {
      const retList: MonicaObject[] = [];
      //   let id: String;

      // 子供一覧の整理（※ないものはリストから削除する）
      for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
        if ((this.childList[i] as MonicaObject).spt == null) {
          // リスト削除
          this.childList.splice(i, 1);
        }
      }
      // 返却リストの作成
      for (let i = 0; i < this.childList.length; i += 1) {
        if ((this.childList[i] instanceof marietta.webcad.item.parts.UpStair)) continue;
        if ((this.childList[i] instanceof marietta.webcad.item.parts.RoomText)) continue;
        if ((this.childList[i] instanceof marietta.webcad.item.GroupItem)) continue;
        // id = (this.childList[i] as MonicaObject).itemInfo.id;
        retList.push(this.childList[i]);
      }
      return retList;
    }

    /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
    moveAllItems(moveX: number, moveY: number): void {
      let target: MonicaObject;
      for (let i: number = 0; i < this.childList.length; i += 1) {
        target = this.childList[i] as MonicaObject;
        target.move(target.itemInfo.x + moveX, target.itemInfo.y + moveY);
      }
    }

    /**
     * 子供を全て削除
     */
    removeAllChildren(): void {
      const list = this.getAllChildren();
      let target: MonicaObject;
      for (let i: number = list.length - 1; i >= 0; i -= 1) {
        target = list[i] as MonicaObject;
        target.deleteMe();
      }
      this.childList = [];
    }

    /**
     * ターゲットコードのアイテムがあるか否か
     */
    hasItemByCode(code: string):boolean {
      const items: MonicaObject[] = this.getAllChildren();

      for (let i: number = 0; i < items.length; i += 1) {
        if ((items[i]).itemInfo.id === code) return true;
      }

      return false;
    }

    /**
     * アイテムを前面へ
     */
    moveFront(target: MonicaObject):void {
      const foundIndex: number = this.getItemIndex(target);
      if (Number.isNaN(foundIndex)) return;
      const insertIndex = foundIndex + 1;
      this.moveItemInList(target, foundIndex, insertIndex);
    }

    /**
     * アイテムを背面へ
     */
    moveBack(target: MonicaObject) :void {
      const foundIndex: number = this.getItemIndex(target);
      if (Number.isNaN(foundIndex)) return;
      const insertIndex = foundIndex - 1;
      this.moveItemInList(target, foundIndex, insertIndex);
    }

    /**
     * アイテムを最前面へ
     */
    moveTop(target: MonicaObject):void {
      const foundIndex: number = this.getItemIndex(target);
      if (Number.isNaN(foundIndex)) return;
      const insertIndex = this.childList.length;
      this.moveItemInList(target, foundIndex, insertIndex);
    }

    /**
     * アイテムを最背面へ
     */
    moveBottom(target: MonicaObject):void {
      const foundIndex: number = this.getItemIndex(target);
      if (Number.isNaN(foundIndex)) return;
      const insertIndex = 0;
      this.moveItemInList(target, foundIndex, insertIndex);
    }

    /**
     * アイテムのIndexを調べる
     */
    getItemIndex(target: MonicaObject):number {
      for (let i: number = 0; i < this.childList.length; i += 1) {
        if (this.childList[i] === target) {
          return i;
        }
      }
      return NaN;
    }

    /**
     * アイテムを最背面へ
     */
    moveItemInList(target: MonicaObject, fromIndex: number, toIndex: number):void {
      if (fromIndex === undefined) return;

      // 取り出す
      this.childList.splice(fromIndex, 1);
      if (toIndex < 0) toIndex = 0;
      if (this.childList.length < toIndex) toIndex = this.childList.length;
      // 挿入
      this.childList.splice(toIndex, 0, target);

      //部屋ならば見積一覧を更新する（パース中は部屋・壁が未生成のため走らせない。読込完了後にloadPlan側で一括再構築される）
      if( target instanceof Room && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects){
        marietta.webcad.WebCADGlobal.quotationItemList.createData();
      }
    }

    /**
     * 特定アイテムコードのアイテムを全て削除
     */
    removeChildrenByCode(code: string): void {
      const list = this.getAllChildren();
      let target: MonicaObject;
      for (let i: number = list.length - 1; i >= 0; i -= 1) {
        target = list[i] as MonicaObject;
        if (target.itemInfo.id !== code) continue;

        // アイテム削除
        target.deleteMe();
        this.childList.splice(i, 1);
      }
    }

    /**
     * 初期化
     */
    format(): void {
      // 返却リストの作成
      for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
        if (!(this.childList[i] instanceof marietta.webcad.item.MonicaObject)) continue;
        if ((this.childList[i] as MonicaObject).itemInfo.lock) continue;
        (this.childList[i] as MonicaObject).deleteMe(null, true);
        this.childList.splice(i, 1);
      }
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      // this.childList = [];
    }

    /**
     *
     * @param guid
     * @returns
     */
    getChildrenWithGuid(guid:string) {
      const item: MonicaObject = (this.childList.length > 0) ? this.childList.find((obj) => obj instanceof MonicaObject && obj.itemInfo.guid === guid) : null;
      return item;
    }
}
